/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EsercenteImportazioneEsitoDTO } from './esercente-importazione-esito-dto';


export interface EsercenteImportazioneRisultatoDTO { 
    esiti?: Array<EsercenteImportazioneEsitoDTO>;
    create?: number;
    saltate?: number;
    errori?: number;
}

